import React, { Component, Fragment } from 'react'
import '../../styles/Popup.module.css'
import {
    Form,
    Select,
    Input,
    Button,
    Upload,
    Row,
    Col,
    Modal,
    Space,
} from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage } from '../../actions';

import PopupManager from '../../managers/PopupManager';
import LayoutSlotsSelector from '../views/LayoutSlotsSelector';
import LayoutTemplatesSelector from '../views/LayoutTemplatesSelector';
import CustomizeLayoutPopup from './CustomizeLayoutPopup';
import CreateLayoutTemplatePage from './CreateLayoutTemplatePage';
const { Option } = Select;

const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
};


class EditLayoutPopup extends Component {
    constructor(props) {
        super(props);
        this.layoutTemplateSelectorRef = React.createRef();
        this.state = { fileList: [], currentLayout: null, showCustomize: false, showCreateTemplate: false };
        this.reloadTemplateHook = () => { }
    }

    componentDidMount() {
        const { timelineLayoutData } = this.props;
        this.setState({ currentLayout: timelineLayoutData.Layout })
    }

    onTemplateNeedsApply = (template) => {
        this.setState({ currentLayout: JSON.stringify(template) });
    }

    finalizeChannalsToLayoutSlots = (TTLOchannelsString, TTLOLayoutString) => {



        const raw = JSON.parse(TTLOchannelsString);

        const allowed = JSON.parse(TTLOLayoutString).slots.map(slot => slot.slot_id);

        const filtered = Object.keys(raw)
            .filter(key => allowed.includes(key))
            .reduce((obj, key) => {
                return {
                    ...obj,
                    [key]: raw[key]
                };
            }, {});

        return filtered
    }

    save = () => {

        const { timelineLayoutData, requestServerPost, usertoken, selectedBrandData, data = null } = this.props;
        var params = new FormData();

        params.append("timelinelayoutid", timelineLayoutData.TLLID);
        params.append("layout", this.state.currentLayout);

        var chJSON = timelineLayoutData.channelJSON;
        // chJSON = chJSON.filter((ch)=>{
        //     return 
        // })




        params.append("channels", JSON.stringify(this.finalizeChannalsToLayoutSlots(timelineLayoutData.Channels, this.state.currentLayout)));
        // params.append("startplaytime", timelineLayoutData.startplaytime ? timelineLayoutData.startplaytime : "");
        params.append("brandid", selectedBrandData.BrandID);
        requestServerPost("update_timelinelayout", params, {}, (response) => {

            PopupManager.closePopup();
        }, usertoken);
    }

    showCreateTemplatePopup = () => {
        this.setState({ showCreateTemplate: true })
    }

    handleCreateTemplateOk = () => {
        this.setState({ showCreateTemplate: false }, () => {

            this.reloadTemplateHook()
            // if (this.layoutTemplateSelectorRef.current) {
            //     this.layoutTemplateSelectorRef.current.reloadTemplates();
            // }
        });

    }

    handleCreateTemplateCancel = () => {
        this.setState({ showCreateTemplate: false });
    }

    showCustomizePopup = () => {
        this.setState({ showCustomize: true });
    }

    handleOk = () => {
        this.setState({ showCustomize: false });
    }

    handleCancel = () => {
        this.setState({ showCustomize: false });
    }

    onApplyCustomLayout = (customLayout) => {
        this.setState({ currentLayout: JSON.stringify(customLayout), showCustomize: false });
    }

    render() {
        const { timelineLayoutData, selectedBrandData } = this.props;
        const previewStyle = {
            display: 'inline',
            width: 100,
            height: 100,
        };
        const previewSize = typeof window !== "undefined" && window.innerWidth < 360 ? 200 : 250;
        return (
            <div key="editlayoutpopup" className="popupcontentcontainer edit-layout-popup" style={{ height: "100%" }}>
                <Row gutter={[0, 16]} justify="space-around" className="edit-layout-row" style={{ width: "100%", height: "100%", padding: "24px" }}>
                    <Col span={24} className="edit-layout-header-col" style={{ padding: "40px" }}>
                        <div className="edit-layout-title" style={{ fontSize: 38, fontWeight: 400, lineHeight: "38px", width: "250px", margin: "0 0 0 0" }}>
                            Edit Layout
                        </div>
                    </Col>
                    <Col span={12} className="edit-layout-col edit-layout-preview-col">
                        <div className="edit-layout-preview-box" style={{ width: "350px", maxWidth: "100%", aspectRatio: "1 / 1", border: "1px solid #DDDDDD", display: "flex", flexDirection: "column" }}>
                            <div className="center-content" style={{ flex: "1 1 auto", minHeight: 0, width: "100%" }}>
                                {this.state.currentLayout ? <LayoutSlotsSelector onChange={(selectedSlot) => {
                                    this.setState({ selectedSlotID: selectedSlot })
                                }} disabled selectedSlotID={this.state.selectedSlotID} style={{}} size={previewSize} layoutData={this.state.currentLayout}></LayoutSlotsSelector> : null}
                            </div>
                            <div className="center-content" style={{ flex: "0 0 auto", width: "100%", padding: "8px 0" }}>
                                <Space wrap style={{ justifyContent: "center", width: "100%" }}>
                                    <Button type="secondary" shape="round" onClick={this.showCustomizePopup}>Customize</Button>
                                    <Button type="secondary" shape="round" onClick={this.showCreateTemplatePopup}>Save as New Template</Button>
                                </Space>
                            </div>
                        </div>
                    </Col>
                    <Col span={12} className="edit-layout-col edit-layout-templates-col">
                        <div className="edit-layout-templates-panel" style={{ float: "right", height: "350px", overflow: "hidden", padding: "24px", backgroundColor: "#f9f9f9" }}>
                            <LayoutTemplatesSelector ref={this.layoutTemplateSelectorRef} setReloadTemplateHook={(hook) => { this.reloadTemplateHook = hook }} brandid={selectedBrandData.BrandID} onTemplateNeedsApply={this.onTemplateNeedsApply}></LayoutTemplatesSelector>
                        </div>
                    </Col>
                    <Col span={24} style={{ textAlign: "right", float: "right" }}>
                        <Button className="edit-layout-save-btn" type="primary" onClick={this.save}>Save Layout</Button>
                    </Col>
                </Row>
                <Modal
                    width={850}
                    title="CUSTOMIZE LAYOUT"
                    open={this.state.showCustomize}
                    footer={null}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    destroyOnClose={true}
                >
                    <CustomizeLayoutPopup onApplyLayout={this.onApplyCustomLayout} onDiscard={this.handleCancel} layout={this.state.currentLayout}></CustomizeLayoutPopup>
                </Modal>
                <Modal
                    width={850}
                    title={null}
                    open={this.state.showCreateTemplate}
                    footer={null}
                    onOk={this.handleCreateTemplateOk}
                    onCancel={this.handleCreateTemplateCancel}
                    destroyOnClose={true}
                >
                    <CreateLayoutTemplatePage template={JSON.parse(this.state.currentLayout)} onTemplateCreated={this.handleCreateTemplateOk}></CreateLayoutTemplatePage>
                </Modal>
            </div >
        );
    }
}

const Styles = {

}


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData };
}

export default connect(mapStateToProps, { requestServerPost, requestServerPost, selectPage })(EditLayoutPopup);
